<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <span class="h5">
                    Cronogramas de Desembolso Sebrae
                </span>
            </b-card-header>
            <b-card-body>
                <div>
                    <app-erros-box
                        :erros="erros"
                        v-if="erros.length > 0"
                    ></app-erros-box>
                    <app-tabela
                        :itens="cronogramasDesembolsoSebrae"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <btn-inserir-cronograma-desembolso-sebrae
                                :pleito="pleito"
                                class="mr-2"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-inserir-cronograma-desembolso-sebrae>
                        </b-button-group>
                    </template>
                    <template slot="acoes" slot-scope="data">
                            <btn-excluir-cronograma-desembolso-sebrae
                                :pleito="pleito"
                                class="text-danger float-left mr-1"
                                :cronogramaDesembolsoSebrae="data"
                                :dataServicos="dataServicos"
                                @atualizarLista="atualizarLista()">
                            </btn-excluir-cronograma-desembolso-sebrae>
                    </template>
                    <template slot="mes" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.mes ? $moment(data.mes).format('MM/YYYY') : '' }}
                        </p>
                    </template>
                    <template slot="parcela" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.parcela }}
                        </p>
                    </template>
                    <template slot="descritivo" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.descritivo }}
                        </p>
                    </template>
                    <template slot="valor" slot-scope="data">
                        <p class="text-left m-0">
                            {{ data.valor | toCurrency }}
                        </p>
                    </template>
                    </app-tabela>
                </div>
            </b-card-body>
        </b-card>
    </div>
</template>
    
<script>
import BtnInserirCronogramaDesembolsoSebrae from './BtnInserirCronogramaDesembolsoSebrae'
import BtnExcluirCronogramaDesembolsoSebrae from './BtnExcluirCronogramaDesembolsoSebrae'

export default {
    components: {
        BtnInserirCronogramaDesembolsoSebrae,
        BtnExcluirCronogramaDesembolsoSebrae
    },

    props: {
        dataServicos: {
            type: Object
        },
        pleito: {
            type: Object,
        },
        pleitoCronogramasDesembolsoSebrae: {
            type: Array,
        }
    },

    data() {
        return {
            erros: [],
            cronogramasDesembolsoSebrae: [],
            cronogramaDesembolsoSebrae:null,
            itensPorPagina: 5,
            campos: [
                {
                    key: 'mes',
                    label: 'Mês',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'parcela',
                    label: 'Parcela',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],

        }
    },

    methods:{
        atualizarLista() {
            this.$store.dispatch('addRequest')
            this.dataServicos.obterCronogramasDesembolsoSebrae(this.$route.params.pleitoId).then((response) => {
            if (response) {
                if (response.success) {
                    this.cronogramasDesembolsoSebrae = response.data
                } else {
                    this.erros = response.errors
                }
            }
            this.$store.dispatch('removeRequest')
            })
        },
    },
    mounted() {
        this.cronogramasDesembolsoSebrae = this.pleitoCronogramasDesembolsoSebrae
    }
}
</script>
